import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoTypeaheadCidadeComponent } from './novo-typeahead-cidade.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoTypeaheadCidadeComponent],
  exports: [NovoTypeaheadCidadeComponent]
})
export class NovoTypeaheadCidadeModule {}
